// @flow

import _ from 'lodash';
import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { CROSS_SELL_IMAGE_URLS } from 'client/components/plan/constants/cardIcons';
import COLORS from 'client/constants/colors';
import CORE_PRODUCT_TYPES from 'client/constants/productTypes';
import Translate from 'client/components/translate';

import type { AppType } from 'web-core/types/ifp-app';

const CrossSellProductCard = styled.div`
  align-items: center;
  background-color: white;
  border-radius: ${rem(4)};
  border: 1px solid ${COLORS.PRIMARY_700};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  line-height: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  img {
    width: ${rem(60)};
    margin-right: 1rem;
  }
`;
const AddButton = styled.button`
  padding: 0.125rem;
  border: none;
  background: ${COLORS.PRIMARY_700};
  font-size: 1.75rem;
  color: ${COLORS.NEUTRAL_50};
  position: relative;
  height: 2.5rem;
  width: 2.5rem;
  display: inline-block;
  border-radius: 50%;
  font-weight: 600;
  text-align: center;
  min-width: ${rem(40)};
`;
export const CrossSellHeader = styled.h4`
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: 1.5rem;
  margin-bottom: 0.25rem;
`;
export const CrossSellPrice = styled.div`
  color: ${COLORS.NEUTRAL_900};
  font-size: ${rem(14)};
  margin-bottom: 0.25rem;
  .price {
    padding: 0 0.5rem;
  }
  span {
    background-color: ${COLORS.SUCCESS_50};
    display: inline-block;
  }
`;
export const CrossSellBenefit = styled.p`
  font-size: ${rem(12)};
  line-height: 1rem;
  margin-top: 0.5rem;
`;

const CompleteCoverageCopy = (type: AppType) => (
  <div>
    <CrossSellHeader>
      <Translate path={`ede.complete.completeYourCoverage.${type}`} />
    </CrossSellHeader>
    <CrossSellPrice>
      <Translate className="price" path={`ede.complete.completeYourCoverage.${type}Price`} />
    </CrossSellPrice>
    <CrossSellBenefit>
      <Translate path={`ede.complete.completeYourCoverage.${type}Benefit`} />
    </CrossSellBenefit>
  </div>
);

type Props = {
  crossSellHandler: Function,
  excludeTypes: Array<string>,
  renderCrossSellCopy: Function,
};

const CrossSellButton = ({ crossSellHandler, excludeTypes, renderCrossSellCopy }: Props) => {
  let crossSellProducts = [CORE_PRODUCT_TYPES.DENTAL, CORE_PRODUCT_TYPES.VISION];
  if (!_.isEmpty(excludeTypes)) {
    crossSellProducts = _.without(crossSellProducts, ...excludeTypes);
  }
  return (
    <React.Fragment>
      {_.map(crossSellProducts, type => (
        <CrossSellProductCard
          key={type}
          onClick={(e) => {
            e.preventDefault();
            crossSellHandler(type);
          }}>
          <div className="flex-row pad-right">
            <img alt={type} src={`${CROSS_SELL_IMAGE_URLS[type]}`} />
            {renderCrossSellCopy(type)}
          </div>
          <AddButton>+</AddButton>
        </CrossSellProductCard>
      ))}
    </React.Fragment>
  );
};

CrossSellButton.defaultProps = {
  excludeTypes: [],
  renderCrossSellCopy: CompleteCoverageCopy,
};

export default CrossSellButton;
